var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.25C15.5 1.83579 15.8358 1.5 16.25 1.5H21.75C22.1642 1.5 22.5 1.83579 22.5 2.25V7.75C22.5 8.16421 22.1642 8.5 21.75 8.5C21.3358 8.5 21 8.16421 21 7.75V4.06066L14.7803 10.2803C14.4874 10.5732 14.0126 10.5732 13.7197 10.2803C13.4268 9.98743 13.4268 9.51256 13.7197 9.21967L19.9393 3H16.25C15.8358 3 15.5 2.66421 15.5 2.25Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.25C2.5 3.2835 3.2835 2.5 4.25 2.5H12.75C13.1642 2.5 13.5 2.83579 13.5 3.25C13.5 3.66421 13.1642 4 12.75 4H4.25C4.11193 4 4 4.11193 4 4.25V19.75C4 19.8881 4.11193 20 4.25 20H19.75C19.8881 20 20 19.8881 20 19.75V11.25C20 10.8358 20.3358 10.5 20.75 10.5C21.1642 10.5 21.5 10.8358 21.5 11.25V19.75C21.5 20.7165 20.7165 21.5 19.75 21.5H4.25C3.2835 21.5 2.5 20.7165 2.5 19.75V4.25Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.0a200ae9.svg";
export { ForwardRef as ReactComponent };